import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=33b1ea1d&scoped=true&lang=pug&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=33b1ea1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b1ea1d",
  null
  
)

export default component.exports